"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = __importDefault(require("@ant-design/icons"));
var react_1 = __importDefault(require("react"));
var NewPageIcon = react_1.default.forwardRef(function (props, ref) { return (react_1.default.createElement("div", null,
    react_1.default.createElement(icons_1.default, __assign({ style: { marginLeft: '10px' } }, props, { component: function () { return (react_1.default.createElement("svg", { ref: ref, width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M12 0V12H0V0H12ZM7.92 2.4H2.4V9.6H9.6V4.08L5.4 8.28L3.72 6.6L7.92 2.4Z", fill: "white" }))); } })))); });
exports.default = NewPageIcon;
